import { CompanyEmail } from "../company-email/company-email";
import { CompanyTelefon } from "../company-telefon/company-telefon";
import { CompanyZrc } from "../company-zrc/company-zrc";


export class CompanyUvozNBS{
    constructor(){}

    ID: number = null;
    Naziv: string = null;
    SNaziv: string = null;
    Pib: string = null;
    MaticniBroj: string = null;
    Adresa: string = null;
    MestoID: number = null;
    Web: string = null;
    LanguageID: number = null;
    ValutaID: number = null;

    Emaili: CompanyEmail[] = null;
    Telefoni: CompanyTelefon[] = null;
    ZiroRacuni: CompanyZrc[] = null;
    TipKomitentaID : number = 1;
    Jbkjs: string = null;

    Deserialize(input:any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.SNaziv = input.SNaziv;
        this.Pib = input.Pib;
        this.MaticniBroj = input.MaticniBroj;
        this.Adresa = input.Adresa;
        this.MestoID = input.MestoID;
        this.Web = input.Web;
        this.LanguageID = input.LanguageID;
        this.ValutaID = input.ValutaID;
        this.Jbkjs = input.Jbkjs;

        if (input.Emaili!=null){
            this.Emaili=[];
            input.Emaili.forEach(Item => {
                return this.Emaili.push(new CompanyEmail().Deserialize(Item))
            });
        }
        if (input.Telefoni!=null){
            this.Telefoni=[];
            input.Telefoni.forEach(Item => {
                return this.Telefoni.push(new CompanyTelefon().Deserialize(Item))
            });
        }
        if (input.ZiroRacuni!=null){
            this.ZiroRacuni=[];
            input.ZiroRacuni.forEach(Item => {
                return this.ZiroRacuni.push(new CompanyZrc().Deserialize(Item))
            });
        }
        return input;

    }

}